module.exports = __webpack_public_path__ + "img/1-en.bcb07bb1.jpg";